module.exports = {"libs.subscriptionActivate.message.required":"必須","libs.subscriptionActivate.message.invalidPassword":"パスワードは8文字でなければなりません。 更新してください。"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/ja/libs/subscriptionActivate.json
// module id = 840
// module chunks = 0